import { Injectable } from "@angular/core";
import { OrderResponseModel, LeadResponseModel } from "../_models/index";
import { DocumentsEntity } from "../_models/order/OrderResponseModel";
import { AncillaryOrderResponseModel } from "../_models/order/AncillaryOrderResponseModel";

@Injectable()
export class GlobalService {
    API_BASE_URL: any;
    getAuthToken(): any {
        throw new Error("Method not implemented.");
    }
    //START - Constants
    public readonly currencyList = [
        "USD",
        "CAD",
        "AUD",
        "EUR",
        "GBP",
        "NZD",
        "CNY",
        "MYR",
        "SGD",
        "SEK",
        "AED",
        "SAR",
        "NOK",
        "CHF",
        "JPY",
        "HKD",
        "DKK",
        "ZAR",
        "THB",
    ];

    public readonly productCategoryTypeEnum = {
        REMITTANCE: "REM",
        FOREXBUY: "FX-BUY",
        FOREXSELL: "FX-SURRENDER",
        FOREXRELOAD: "FX-RELOAD",
        FOREXBALANCE: "FX-BALANCE",
        BULKORDERS: "BULKORDERS",
    };

    public readonly productTypeEnum = {
        REMITTANCE: "REMITTANCE",
        CASH: "CASH",
        FOREXCARD: "FOREXCARD",
        FOREXRELOAD: "FOREXRELOAD",
        DEMAND_DRAFT: "DEMAND_DRAFT",
    };
    public readonly productTypeDisplayEnum = {
        REMITTANCE: "Remittance",
        CASH: "Cash",
        FOREXCARD: "Forex Card",
        DEMAND_DRAFT: "Demand Draft",
        FOREXRELOAD: "Forex Reload",
        FOREXBALANCE: "Forex Balance",
    };

    public readonly productSellTypeEnum = { BUY: "BUY", SELL: "SELL" };

    public readonly productPurposeTypeEnum = {
        EDUCATION: "EDUCATION",
        PRIVATE_VISIT: "PRIVATE_VISIT",
    };
    public readonly occupationListItems = [
        "SERVICE",
        "HOMEMAKER",
        "STUDENT",
        "BUSINESS",
        "RETIRED",
        "SELF_EMPLOYED",
        "OTHERS",
    ];

    public readonly commentSource = {
        CUSTOMER: "CUSTOMER",
        AGENT: "AGENT",
        ADMIN: "ADMIN",
        IW_CALL: "IW_CALL",
        OW_CALL: "OW_CALL",
        BRANCH_VISIT: "BRANCH_VISIT",
        HOME_VISIT: "HOME_VISIT",
        COMPLIANCE_CLARIFICATION: "COMPLIANCE_CLARIFICATION",
        RESOLUTION: "RESOLUTION",
        OPERATIONS: "OPERATIONS",
        OTHERS: "OTHERS",
    };

    public readonly commentPurpose = {
        KYC: "KYC",
        COMPLIANCE: "COMPLIANCE",
        PAYMENT: "PAYMENT",
        DOCUMENTS: "DOCUMENTS",
        A2FORM: "A2FORM",
        HEDGE: "HEDGE",
        OTHERS: "OTHERS",
    };

    public readonly kycMedium = {
        AADHAR: "AADHAR",
        PASSPORT: "PASSPORT",
        DL: "DL",
        VOTERID: "VOTERID",
    };
    // public readonly deliveryStatus = { APPROVED: 'APPROVED', TO_BE_SCHEDULED: 'TO_BE_SCHEDULED', SCHEDULED: 'SCHEDULED', OUT_OF_DELIVERY: 'OUT_OF_DELIVERY', DELIVERED: 'DELIVERED' };
    public readonly deliveryStatus = ["TO_BE_SCHEDULED", "APPROVED"];
    public readonly deliveryStatusApproved = [
        "TO_BE_SCHEDULED",
        "APPROVED",
        "SCHEDULED",
    ];
    public readonly deliveryStatusScheduled = [
        "TO_BE_SCHEDULED",
        "APPROVED",
        "SCHEDULED",
        "OUT_FOR_DELIVERY",
    ];
    public readonly deliveryStatusOutForDelivery = [
        "TO_BE_SCHEDULED",
        "APPROVED",
        "SCHEDULED",
        "OUT_FOR_DELIVERY",
        "DELIVERED",
    ];
    public readonly deliveryStatusDelivered = ["DELIVERED"];

    public readonly deliveryTimeSlot = [
        "10-11 AM",
        "11-12 PM",
        "12-01 PM",
        "01-02 PM",
        "02-03 PM",
        "03-04 PM",
        "04-05 PM",
        "05-06 PM",
    ];

    public readonly chargesType = { NOSTRO: "Nostro", SERVICE: "Service" };
    // public readonly leadStatus = { New: 'NEW', NotInterested: 'NOT_INTERESTED', CallLater: 'CALL_LATER', Converted: 'CONVERTED', Closed: 'CLOSED' };

    public readonly leadStatus = [
        { label: "Open", value: "OPEN" },
        { label: "Not Interested", value: "NOT_INTERESTED" },
        { label: "Call Later", value: "CALL_LATER" },
        { label: "Converted", value: "CONVERTED" },
        { label: "Closed", value: "CLOSED" },
    ];
    //Deep Linking
    public readonly pageListEnum = [
        { pageId: "LANDING_PAGE", pageName: "Landing page" },
        { pageId: "SETTINGS", pageName: "Settings" },
        { pageId: "BUY_NEW_CARD", pageName: "Buy New card" },
        { pageId: "CARD", pageName: "Card" },
        { pageId: "MANAGE_CARD", pageName: "Manage Card" },
        { pageId: "REMITTANCE", pageName: "Remittance" },
        {
            pageId: "UNIVERSITY_FEES_REMITTANCE",
            pageName: "University Fees (Remittance)",
        },
        { pageId: "OTHERS_REMITTANCE", pageName: "Others (Remittance)" },
        { pageId: "MY_ORDERS", pageName: "My Orders" },
        { pageId: "CARD_STATEMENT", pageName: "Statement" },
        { pageId: "UNLOCK_VOUCHERS", pageName: "Unlock Vouchers" },
        { pageId: "ATM_LOCATORS", pageName: "ATM Locator" },
        { pageId: "REWARDS_AND_REFERRALS", pageName: "Rewards & Referrals" },
        { pageId: "REDEEM", pageName: "Redeem" },
        { pageId: "REFER_AND_EARN", pageName: "Refer & Earn" },
        { pageId: "OFFERS", pageName: "Offers" },
        { pageId: "PROFILE", pageName: "Profile" },
        { pageId: "ISIC_CARD_APPLICATION", pageName: "ISIC Card Application" },
        { pageId: "SERVICE_REQUEST", pageName: "Service Request" },
    ];

    //END - Constants
    public readonly nostroPayerEnum = {
        REMITTER: "REMITTER",
        BENEFICIARY: "BENEFICIARY",
    };
    public readonly serviceproductTypeEnum = [
        "REMITTANCE",
        "REMITTANCE",
        "CASH",
        "CASH",
        "FOREXCARD",
        "FOREXCARD",
        "DEMAND_DRAFT",
        "DEMAND_DRAFT",
    ];
    public readonly serviceOperationsList = ["PURCHASE", "CANCELLATION"];
    public readonly serviceproductList = [
        "REMITTANCE",
        "CASH",
        "FOREXCARD",
        "DEMAND_DRAFT",
    ];

    //global var
    public currentUser: any = null;
    order: OrderResponseModel = new OrderResponseModel(); //Orderdetail
    public ancillaryOrder: AncillaryOrderResponseModel;
    currentOrderId = "";
    currentOrderWsfxBranchId = "";
    currentOrderWsfxBranchId_temp = "";
    public product = false;
    public currentSelectedPartner: any;
    public customerData = null;
    public displayData = null;
    public documentList = false;
    public orderFullName = "";
    public orderMobile = "";
    public orderEmail = "";
    public orderPhoto = "";
    public customerStatus = "Incomplete";
    public statusConsumerKyc = "";
    public currentDocument: DocumentsEntity = null;
    public currentLead: LeadResponseModel = null;
    public orderCount = 0;

    constructor() {
        this.getCurrentUser();
    }

    getCurrentUser() {
        console.log(this.currentUser);
        if (this.currentUser === null) {
            this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
            console.log(this.currentUser);
        }
    }

    titleCaseWord(word: string) {
        if (word) {
            var sentence = word.toLowerCase().split(" ");
            for (var i = 0; i < sentence.length; i++) {
                sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1);
            }
            return sentence.toString().replace(/,/g, " ");
        }

        return "-";
    }
}



// WEBPACK FOOTER //
// ./src/app/_global/global.service.ts